/**
 * Telegram Mini App helpers for Zen Dashboard
 */

export function initTelegram() {
  try {
    const wa = window.Telegram?.WebApp
    if (wa) {
      wa.ready()
      wa.expand()
      wa.setHeaderColor('#0a0a0f')
      wa.setBackgroundColor('#0a0a0f')
    }
    console.log('Telegram Mini App initialized')
  } catch (e) {
    console.warn('Not in Telegram environment:', e)
  }
}

export function getUser() {
  return window.Telegram?.WebApp?.initDataUnsafe?.user
}

export function getInitData(): string {
  return window.Telegram?.WebApp?.initData || ''
}

export function hapticFeedback(style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft' = 'medium') {
  try {
    window.Telegram?.WebApp?.HapticFeedback?.impactOccurred(style)
  } catch {}
}

export function hapticNotification(type: 'error' | 'success' | 'warning' = 'success') {
  try {
    window.Telegram?.WebApp?.HapticFeedback?.notificationOccurred(type)
  } catch {}
}

export function openLink(url: string) {
  try {
    window.Telegram?.WebApp?.openLink(url)
  } catch {
    window.open(url, '_blank')
  }
}

declare global {
  interface Window {
    Telegram?: {
      WebApp: {
        initData: string
        initDataUnsafe: {
          user?: {
            id: number
            first_name: string
            last_name?: string
            username?: string
          }
        }
        ready: () => void
        expand: () => void
        close: () => void
        setHeaderColor: (color: string) => void
        setBackgroundColor: (color: string) => void
        openLink: (url: string) => void
        openTelegramLink: (url: string) => void
        HapticFeedback?: {
          impactOccurred: (style: string) => void
          notificationOccurred: (type: string) => void
        }
      }
    }
  }
}
